import Tags from 'assets/icons/tags.svg';
import Truck from 'assets/icons/truck.svg';
import Coin from 'assets/icons/coins_big.svg';
import BoxOpen from 'assets/icons/box-open.svg';
import UserGear from 'assets/icons/user-gear.svg';
import ChartUser from 'assets/icons/chart-user.svg';
import CartShoppingFast from 'assets/icons/cart-shopping-fast.svg';
import CloudUploadInternal from 'assets/icons/cloud-upload-internal.svg';

const gap = { gap: { tablet: '10px', laptop: '20px' } };

const GENERAL_CARD_TITLE_PROPS = {
  fontSize: { mobile: 'unset', tablet: '24px', laptop: '32px', desktop: '24px' },
};

export const retailTechExpertData = {
  title: 'Наши решения для ключевых направлений розничной торговли',
  titleProps: {
    maxW: { mobile: '340px', tablet: '515px', laptop: '1000px' },
    fontSize: { mobile: '28px', tablet: '36px', laptop: '64px', desktop: '48px' },
  },
  tabTitleProps: { fontSize: { mobile: '18px', laptop: '24px', desktop: '20px' } },

  cardsData: [
    {
      title: 'Ассортимент и закупки',
      tabIcon: BoxOpen,
      titleProps: GENERAL_CARD_TITLE_PROPS,
      content: [
        'Автоматизируем закупки и управление ассортиментом, делаем планирование точным и прозрачным.',
        ` •	модели на основе искусственного интеллекта для прогнозирования спроса; <br />
          •	интеграция с системами планирования ресурсов предприятия (ERP) и системами поставщиков; <br />
          •	автоматическое формирование заказов и контроль остатков.`,
        'Это снижает издержки, исключает дефицит и повышает оборачиваемость товаров',
      ],
      gap,
    },
    {
      title: 'Логистика',
      tabIcon: Truck,
      titleProps: GENERAL_CARD_TITLE_PROPS,
      content: [
        'Оптимизируем логистику и управление цепочками поставок, обеспечиваем прозрачность и контроль на всех этапах движения товаров.',
        ` •	системы управления цепочками поставок (SCM); <br />
          •	решения на базе Интернета вещей (IoT) для мониторинга состояния и перемещения продукции; <br />
          •	автоматическое пополнение запасов и оптимизация маршрутов доставки.`,
        'Это снижает операционные издержки, ускоряет поставки и повышает устойчивость логистики',
      ],
      gap,
    },
    {
      title: 'Ценообразование и рекламные акции',
      tabIcon: Tags,
      titleProps: GENERAL_CARD_TITLE_PROPS,
      content: [
        'Внедряем решения для динамического ценообразования и управления рекламными акциями.',
        ` •	аналитические алгоритмы и модели на основе искусственного интеллекта, которые автоматически корректируют цены с учётом спроса и конкурентов; <br />
          •	интеграции с системами управления взаимоотношениями с клиентами (CRM) для планирования и анализа эффективности кампаний.`,
        'Это помогает увеличивать прибыльность, точнее управлять скидками и избегать потери маржи',
      ],
      gap,
    },
    {
      title: 'Продажи и обслуживание клиентов',
      tabIcon: CartShoppingFast,
      titleProps: GENERAL_CARD_TITLE_PROPS,
      content: [
        'Разрабатываем веб‑ и мобильные приложения для автоматизации обслуживания и управления заказами.',
        ` •	персонализированные интерфейсы и уведомления о скидках; <br />
          •	программы лояльности и управление заказами; <br />
          •	улучшенный дизайн интерфейсов и пользовательский опыт.`,
        'Это повышает удобство для клиентов, увеличивает повторные покупки и снижает нагрузку на персонал',
      ],
      gap,
    },
    {
      title: 'Маркетинг и привлечение клиентов',
      tabIcon: ChartUser,
      titleProps: GENERAL_CARD_TITLE_PROPS,
      content: [
        'Помогаем компаниям розничной торговли сделать маркетинг более эффективным.',
        ` •	системы управления взаимоотношениями с клиентами (CRM) и системы на основе искусственного интеллекта; <br />
          •	запуск персонализированных кампаний и анализ поведения клиентов в реальном времени; <br />
          •	инструменты для оценки эффективности маркетинга.`,
        'Это повышает конверсию, улучшает точность коммуникаций и увеличивает окупаемость инвестиций',
      ],
      gap,
    },
    {
      title: 'Финансы и планирование',
      tabIcon: Coin,
      titleProps: GENERAL_CARD_TITLE_PROPS,
      content: [
        'Разрабатываем аналитические решения для финансового планирования.',
        ` •	интеллектуальные модели прогнозирования спроса и доходов; <br />
          •	автоматизация расчётов и контроля бюджетов; <br />
          •	единая платформа для аналитики и отчётности.`,
        'Это снижает риск ошибок, упрощает процессы планирования и повышает точность управленческих решений',
      ],
      gap,
    },
    {
      title: 'Управление персоналом',
      tabIcon: UserGear,
      titleProps: GENERAL_CARD_TITLE_PROPS,
      content: [
        'Автоматизируем процессы управления персоналом в сфере розничной торговли и создаём цифровые платформы для управления наймом, адаптацией и развитием сотрудников.',
        ` •	внутренние порталы управления персоналом, интегрированные с корпоративными системами; <br />
          •	инструменты для оценки, обучения и коммуникации; <br />
          •	аналитика вовлечённости и эффективности персонала.`,
        'Это повышает прозрачность, ускоряет процессы управления персоналом и укрепляет командную культуру',
      ],
      gap,
    },
    {
      title: 'Цифровая инфраструктура',
      tabIcon: CloudUploadInternal,
      titleProps: GENERAL_CARD_TITLE_PROPS,
      content: [
        'Обеспечиваем стабильную и масштабируемую инфраструктуру информационных технологий.',
        ` •	поддержка серверов, баз данных и облачных сервисов; <br />
          •	внедрение систем мониторинга и подходов к автоматизации разработки и эксплуатации (DevOps); <br />
          •	гарантированная круглосуточная доступность и быстрая реакция на рост нагрузки.`,
        'Это гарантирует надёжность, гибкость и готовность к новым бизнес-требованиям',
      ],
      gap,
    },
  ],
};
